// FB-DEPLOY-008：UAT admin 应用（ORD-DEPLOY-021 注册）纳入缺省主题路由集合；
// dev04 与 UAT 共用一份缺省表，仅用于登录页主题匹配，不影响 OIDC 行为。
const defaultAdminApplicationIds = [
  'demo-app',
  'u4mwzeekl4wbiwvkzn47b',
  'OEGuGvijDjD5LArD1lxNI',
];
const defaultUserApplicationIds = ['kuayltypqiqsfi5i4g63p'];
const defaultMiniAppApplicationIds = ['xkymw795oxy1soeazcnh3'];
const defaultWebApplicationIds = ['l97b1vjrzlpa24h1bmpfn'];

const parseApplicationIds = (value?: string) =>
  value
    ?.split(',')
    .map((applicationId) => applicationId.trim())
    .filter(Boolean);

const configuredAdminApplicationIds = parseApplicationIds(
  process.env.EAVIER_ADMIN_AUTH_APP_IDS ?? process.env.EAVIER_CUSTOM_AUTH_APP_IDS
);
const configuredUserApplicationIds = parseApplicationIds(process.env.EAVIER_USER_AUTH_APP_IDS);
const configuredMiniAppApplicationIds = parseApplicationIds(
  process.env.EAVIER_MINIAPP_AUTH_APP_IDS
);
const configuredWebApplicationIds = parseApplicationIds(process.env.EAVIER_WEB_AUTH_APP_IDS);

export const eavierAdminAuthApplicationIds = new Set(
  configuredAdminApplicationIds?.length
    ? configuredAdminApplicationIds
    : defaultAdminApplicationIds
);

export const eavierUserAuthApplicationIds = new Set(
  configuredUserApplicationIds?.length ? configuredUserApplicationIds : defaultUserApplicationIds
);

export const eavierMiniAppAuthApplicationIds = new Set(
  configuredMiniAppApplicationIds?.length
    ? configuredMiniAppApplicationIds
    : defaultMiniAppApplicationIds
);

export const eavierWebAuthApplicationIds = new Set(
  configuredWebApplicationIds?.length ? configuredWebApplicationIds : defaultWebApplicationIds
);
